import React from 'react';

import { AutocompleteCollection } from '@algolia/autocomplete-core';
import classNames from 'classnames';

import { DocSearchHit } from '../../../../types';
import { getUnifiedCodeLanguage } from '../../../../utils/getUnifiedCodeLanguage';

import * as classes from './style.module.scss';

interface Props {
  title?: string;
  collection: AutocompleteCollection<DocSearchHit>;
}

export const ResultsTitle: React.FC<Props> = ({
  title: persistentTitle,
  collection,
}) => {
  const title = persistentTitle || collection.items[0].name;

  const uniqueQueryValues: string[] = collection.items[0].query
    ? (collection.items[0].query
        .map(queryItem => getUnifiedCodeLanguage(queryItem)?.name)
        .filter(Boolean) as string[])
    : [];

  return (
    <div className={classNames('DocSearch-Hit-source', classes.root)}>
      {title}
      {Boolean(uniqueQueryValues.length) && (
        <div className={classes.container}>
          {uniqueQueryValues.map(queryValue => (
            <span
              key={queryValue}
              className={classNames(classes.item, classes.light)}
            >
              {queryValue}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
